import React from "react";
import { toString } from "lodash";
import "./FormattedErrorToast.css";

const FormattedErrorToast = ({ title, items }) => {
  return (
    <div className="formatted-error-toast">
      <h3 className="toast-title">{title}</h3>
      <ul className="toast-list">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <li className="toast-list-item">
              <span className="toast-item-text">• {toString(item?.title).replace("[", "").replace("]", "")}</span>
              {item.subItems && (
                <ul className="toast-sublist">
                  {item.subItems.map((subItem, subIndex) => (
                    <li key={subIndex} className="toast-sublist-item">
                      <span className="toast-subitem-text">
                        - {toString(subItem).replace("[", "").replace("]", "")}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          </React.Fragment>
        ))}
      </ul>
    </div>
  );
};

export default FormattedErrorToast;
